import React from 'react';
import { connect } from 'react-redux';
import { fetchTournament } from '../actions';
import AdminNavigationBar from './AdminNavigationBar';
import TournamentInfo from './TournamentInfo';

class TournamentEmailShipment extends React.Component {

    constructor() {
        super();
        this.state = {subject: '', content: ''};
        this.sendEmails = this.sendEmails.bind(this);
    }

    componentDidMount() {
      const { dispatch } = this.props;
    
      if (this.tournament() === undefined) {
        dispatch(fetchTournament(this.tournamentId()));
      }
    }

    tournamentId() {
      return parseInt(this.props.match.params.id, 10);
    }

    tournament() {
      return this.props.tournaments.find(tournament => tournament.id === this.tournamentId());
    }

    onSubjectChange() {
        return (evt) => {
            this.setState({ subject: evt.target.value, sent: undefined });
        };
    }

    onContentChange() {
        return (evt) => {
            this.setState({ content: evt.target.value, sent: undefined });
        };
    }

    validationClass(fieldName) {
        if (this.state.invalidFields && this.state.invalidFields.includes(fieldName)) {
          return 'is-invalid';
        } else {
          return '';
        }
    }

    sendEmails() {
        fetch(
          `/api/tournaments/${this.tournamentId()}/participants/email-shipments`,
          {
            method: 'POST',
            headers: {
              'content-type': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              subject: this.state.subject,
              content: this.state.content
            })
          }).then(response => {
            if (response.status === 204) {
                this.setState({sent: true, error: undefined, invalidFields: undefined, subject: '', content: ''});
            } else {
              response.json().then(data => this.setState({
                sent: undefined,
                error: 'Podano nieprawidłowe dane!',
                invalidFields: data.errors
              }));
            }
          });
    }

    render() {
        const tournament = this.tournament();

        if (tournament !== undefined) {
        return (
            <div>
              <AdminNavigationBar />
              <div className="container">
                <h1>Wysyłka e-mail</h1>
                <hr />
                <TournamentInfo tournament={tournament} />
                <hr />
                { this.state.sent ? <div className="inline-block alert alert-info">Zlecono wysyłkę e-maili.</div> : ''}
                { this.state.error ? <div className="inline-block alert alert-danger">{this.state.error}</div> : '' }
                <form>
                    <div className="form-row ml-2">
                        <div className="form-group col-md-6">
                            <label>Temat:</label>
                            <input
                                type="text"
                                className={"form-control " + this.validationClass('subject')}
                                value={this.state.subject}
                                onChange={this.onSubjectChange()}></input>
                        </div>
                    </div>
                    <div className="form-row ml-2">
                        <div className="form-group col-md-6">
                            <label>Treść:</label>
                            <textarea
                                className={"form-control " + this.validationClass('content')}
                                value={this.state.content}
                                style={{height: '200px'}}
                                onChange={this.onContentChange()}></textarea>
                        </div>
                    </div>
                    <div className="form-group">
                        <button className="btn btn-primary" onClick={this.sendEmails}>Wyślij</button>
                    </div>
                </form>
                </div>
            </div>
          );
        } else {
            return (<div></div>);
        }
    }
}

function mapStateToProps(state) {
    return { tournaments: state.tournaments };
}
  
export default connect(mapStateToProps)(TournamentEmailShipment);



// WEBPACK FOOTER //
// ./components/TournamentEmailShipment.js